export default __webpack_public_path__ + "static/media/butcherparts.59110acc.png";